import React, { ComponentType } from 'react';
import { useLoadedData } from '../../../toolympus/hooks/useLoadedData';
import { DocumentationDoc } from '../../../toolympus/components/Documentation/useDocumentationPages';
import { DocumentTitle, PowerEditorBase, PowerEditorBaseProps } from '../../../toolympus/components/PowerDoc';
import { FormWrapper, FormHeader, LoadingIndicator, FormBody } from '../../../toolympus/components/primitives';
import { useDocumentationPagesPlugin } from '../../../toolympus/components/Documentation';
import { ColumnsPlugin } from '../../../toolympus/components/PowerDoc/plugins/Columns';
import { useCustomFieldsViewerPlugin } from '../../../toolympus/components/PowerDoc/plugins/CustomFieldsBlock';
import { ExpanderPlugin } from '../../../toolympus/components/PowerDoc/plugins/Expander';
import { useMediaFilesPlugin } from '../../../toolympus/components/PowerDoc/plugins/MediaFiles';
import { TablesPlugin } from '../../../toolympus/components/PowerDoc/plugins/Tables';
import { TilesPlugin } from '../../../toolympus/components/PowerDoc/plugins/Tiles';
import { RenderElementProps } from 'slate-react';
import { createWrappedPowerEditor } from '../../../toolympus/components/PowerDoc/PowerEditorSettingsContext';
import { DashboardBlock } from './DashboardBlock';

interface Props {
  
}

const CustomBlocks: Record<string, ComponentType<RenderElementProps>> = {
  dashboard: DashboardBlock,
}

const LocusDocumentationViewerUnwrapped = (props: PowerEditorBaseProps) => {
  const mediaFilesPlugin = useMediaFilesPlugin();
  const pagesPlugin = useDocumentationPagesPlugin();
  const customBlocks = useCustomFieldsViewerPlugin(CustomBlocks);

  return (
      <PowerEditorBase
          {...props}
          plugins={[
              TilesPlugin,
              ColumnsPlugin,
              TablesPlugin,
              ExpanderPlugin,
              mediaFilesPlugin,
              pagesPlugin,
              customBlocks,
          ]}
          autoFocus={!props.viewMode}
          viewMode
          />
  );
}

const LocusDocumentationViewer = createWrappedPowerEditor({ EditorComponent: LocusDocumentationViewerUnwrapped });


export const HomePage = (props: Props) => {
  const data = useLoadedData<DocumentationDoc>("/api/documentation/slug/app_home", {
    _id: "",
    content: undefined,
    title: "",
  });

  return (
    <FormWrapper>
      <FormHeader>
        <DocumentTitle
          value={data.data.title}
          placeholder="..."
          update={() => {}}
          readOnly
          style={{ flex: "1 0 auto" }}
          />

        {data.isLoading && <LoadingIndicator sizeVariant="s" />}
      </FormHeader>

      <FormBody>
        <LocusDocumentationViewer
          content={data.data.content}
          key={data.data._id}
          update={() => {}}
          />
      </FormBody>
    </FormWrapper>
  );
}
